import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper, Grid } from '@material-ui/core';
import { Rating } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import FileBase from 'react-file-base64';

import { createPost, updatePost } from '../../actions/posts';
import useStyles from './styles';

const Form = ({ currentId, setCurrentId }) => {
  const [postData, setPostData] = useState({ artist: '', album: '', review: '', tags: '', selectedFile: '' });
  const post = useSelector((state) => (currentId ? state.posts.find((review) => review._id === currentId) : null));
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem('profile'));

  useEffect(() => {
    if (post) setPostData(post);
  }, [post]);

  const clear = () => {
    setCurrentId(0);
    setPostData({ artist: '', album: '', review: '', tags: '', selectedFile: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (currentId === 0) {
      dispatch(createPost({ ...postData, name: user?.result?.name }));
      clear();
    } else {
      dispatch(updatePost(currentId, { ...postData, name: user?.result?.name }));
      clear();
    }
  };

  if (!user?.result?.name) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6" align="center">
          Please Sign In to create your own reviews and like other reviews.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper className={classes.paper}>
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
        <Typography variant="h6">{currentId ? `Editing "${post.artist}"` : 'Creating a Review'}</Typography>
        <TextField name="artist" variant="outlined" label="Artist Name" fullWidth value={postData.artist} onChange={(e) => setPostData({ ...postData, artist: e.target.value })} />
        <TextField name="album" variant="outlined" label="Album Name" fullWidth value={postData.album} onChange={(e) => setPostData({ ...postData, album: e.target.value })} />
        <TextField name="review" variant="outlined" label="Review" fullWidth multiline minRows={4} value={postData.review} onChange={(e) => setPostData({ ...postData, review: e.target.value })} />
        <TextField name="tags" variant="outlined" label="Tags (coma separated)" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })} />
        <Rating name="rating" className={classes.rating} defaultValue={0} precision={0.5} value={postData.rating} onChange={(e) => setPostData({ ...postData, rating: e.target.value })}/>
        <Grid container direction="row" alignItems="center" wrap="nowrap">
          <div className={classes.fileInput}><Typography variant="body2">Upload Album Cover:</Typography><FileBase type="file" multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /></div>
        </Grid>
        <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>
        <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>Clear</Button>
      </form>
    </Paper>
  );
};

export default Form;